import { render, staticRenderFns } from "./restriktionen-segmented-control.vue?vue&type=template&id=14e1e2c4&scoped=true"
import script from "./restriktionen-segmented-control.vue?vue&type=script&lang=js"
export * from "./restriktionen-segmented-control.vue?vue&type=script&lang=js"
import style0 from "./restriktionen-segmented-control.vue?vue&type=style&index=0&id=14e1e2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e1e2c4",
  null
  
)

export default component.exports